// extracted by mini-css-extract-plugin
export var caretAnchor = "_v5-0";
export var dropdownContent = "_v5-1";